import React from 'react';
import './Winterweek.css';
import winter1 from './assets/winter1.jpg';
import winter2 from './assets/winter2.jpg';

function WinterWeek() {
  return (
    <div className="winterweek-container">
      <h1 className="winterweek-title">Winter Week</h1>
      <p className="winterweek-description">
        La Winter Week è un evento annuale organizzato dal CUSAS Unisannio per accogliere gli studenti universitari con una settimana ricca di attività sportive, culturali e ricreative. Un'occasione unica per socializzare, fare nuove amicizie e scoprire le opportunità offerte dall'associazione.
      </p>
      <div className="winterweek-gallery">
        <img src={winter1} alt="Attività invernale" className="winterweek-image" />
        <img src={winter2} alt="Eventi sociali" className="winterweek-image" />
      </div>
    </div>
  );
}

export default WinterWeek;
